import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import productService from '../services/productService';
import ProductForm from '../components/ProductForm';
import '../styles/products.css';
const CreateProductPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async (productData) => {
    setLoading(true);
    setError('');

    try {
      await productService.createProduct(productData);
      navigate('/user/products', {
        replace: true,
        state: { notice: 'Product created successfully.' },
      });
    } catch (err) {
      const validationErrors = err.response?.data?.errors || [];
      const validationMessage = validationErrors
        .map((item) => item.message)
        .join(' ');

      setError(
        validationMessage ||
          err.response?.data?.message ||
          'Unable to create product.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="products-page">
      <div className="products-page-header">
        <div>
          <h1>Add Product</h1>
          <p>Enter the product details for your firm.</p>
        </div>

        <Link
          to="/user/products"
          className="product-secondary-button"
        >
          Back to Products
        </Link>
      </div>

      {error && (
        <div className="product-alert product-alert-error">
          {error}
        </div>
      )}

      <div className="product-form-card">
        <ProductForm
          onSubmit={handleCreate}
          submitLabel="Create Product"
          loading={loading}
        />
      </div>
    </section>
  );
};

export default CreateProductPage;